import React from "react";
import { BsDot } from "react-icons/bs";
import { Link } from "react-router-dom";
import { ResponceMain } from "../OptionRes/ResStyles";

const PricingRes = () => {
  return (
    <ResponceMain>
      <div className="space-between">
        <h3>Pricing</h3>
      </div>
      <p>Money manager has three plans</p>
      <ul>
        <li>
          <BsDot className="dot" />
          Free
        </li>
        <li>
          <BsDot className="dot" />
          Business
        </li>
        <li>
          <BsDot className="dot" />
          Enterprise
        </li>
      </ul>
      <Link to="/pricing">
        <div className="button">See Details</div>
      </Link>
    </ResponceMain>
  );
};

export default PricingRes;
